var features = {};

function register(name, ctor) {
  features[name] = ctor;
}

function get(name) {
  return features[name];
}

exports.register = register;
exports.get = get;


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/toolbox/featureManager.js
// module id = 71
// module chunks = 0